import { apiClient } from '@/shared/api';

import type { AssetResponse, MediaOwnerType, MediaVisibility, UploadAssetParams } from '../model/types';

const BASE = '/api/v1/catalog/media';

/**
 * Upload a product/category photo to web-media-service (via the BFF). Sends a
 * `multipart/form-data` body; the BFF reads `ownerType`/`ownerId`/`visibility` as
 * request params from the form. Returns the asset with its stable `publicUrl`.
 */
export const uploadAsset = async (params: UploadAssetParams): Promise<AssetResponse> => {
  const form = new FormData();
  form.append('file', params.file);
  form.append('ownerType', params.ownerType);
  if (params.ownerId) form.append('ownerId', params.ownerId);
  if (params.visibility) form.append('visibility', params.visibility);
  const { data } = await apiClient.post<AssetResponse>(BASE, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const listAssets = async (params: {
  ownerType: MediaOwnerType;
  ownerId?: string;
  visibility?: MediaVisibility;
}): Promise<AssetResponse[]> => (await apiClient.get<AssetResponse[]>(BASE, { params })).data;

export const getAsset = async (assetId: string): Promise<AssetResponse> =>
  (await apiClient.get<AssetResponse>(`${BASE}/${assetId}`)).data;

export const deleteAsset = async (assetId: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${assetId}`);
};
